import { HTTP_AP_Company, HTTP_AP_Company_ForDetails } from '@api-new/companyservice';
import { createAction, props } from '@ngrx/store';
import { CreateCompanyFormValues } from '@platform/company/pages/company-create/forms/create-company.form';
import { ErrorModel } from '@shared-lib/models/error.model';
import { SharedFileModel } from '@shared-lib/models/shared-file.model';

export const getCompanyById = createAction('[COMPANY] Get Company By ID', props<{ id: string }>());

export const getCompanyByIdSuccess = createAction('[COMPANY] Get Company By ID Success', props<{ company: HTTP_AP_Company_ForDetails }>());

export const getCompanyByIdFailure = createAction('[COMPANY] Get Company By ID Failure', props<{ error: ErrorModel }>());

export const createCompany = createAction('[COMPANY] Create Company', props<{ company: CreateCompanyFormValues }>());

export const createCompanySuccess = createAction('[COMPANY] Create Company Success', props<{ company: HTTP_AP_Company }>());

export const createCompanyFailure = createAction('[COMPANY] Create Company Failure', props<{ error: ErrorModel }>());

export const updateCompanyLogo = createAction('[COMPANY] Update Company Logo', props<{ companyId: string; file: SharedFileModel }>());

export const updateCompanyLogoSuccess = createAction('[COMPANY] Update Company Logo Success', props<{ company: HTTP_AP_Company }>());

export const updateCompanyLogoFailure = createAction('[COMPANY] Update Company Logo Failure', props<{ error: ErrorModel }>());
